"use strict";
exports.isValid = isValid;
var _index = require("./isDate.js");
var _index2 = require("./toDate.js");
function isValid(date) {
  if (!(0, _index.isDate)(date) && typeof date !== "number") {
    return false;
  }
  const _date = (0, _index2.toDate)(date);
  return !isNaN(Number(_date));
}
